import type { Step } from 'react-joyride'

// Walks a consultant through the first recommendation they ever land on:
// what it is, how to edit it, how to share, how to turn it into a quote.
// Keep it to 4 steps — they have a farmer to talk to.
export const recommendationDetailSteps: Step[] = [
  {
    target: '[data-tour="rec-detail-header"]',
    title: 'Here\'s the recommendation',
    content: 'This is the full plan we built for the farmer, organized by crop. Each tab shows the products, rates, and reasoning for that crop.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-detail-edit-btn"]',
    title: 'Make it yours',
    content: 'Don\'t agree with a rate? Want to swap a product? Click Edit. Your changes save with your name on them — the system learns from your overrides.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-detail-share-btn"]',
    title: 'Send it to the farmer',
    content: 'This copies a public link the farmer can open on their phone — no login needed. Great for walking them through the plan on a call.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="rec-detail-quote-btn"]',
    title: 'Turn it into a quote',
    content: 'When the farmer says yes, click here. Only the products YI sells carry over — the rest stays on the recommendation as part of the plan.',
    skipBeacon: true,
    placement: 'bottom',
  },
]
